export default "__VITE_ASSET__BUjAQMOd__"